import * as errors from "../errors.js";
import { state } from "../state.js";

/*
    EXP is a mathematical function that evaluates the inverse natural LOG of the argument. That is, the argument X is applied as an exponent to 
    e(2.71828183). So EXP(X) = eX. Arguments in excess of 89.0296919 result in the BASIC error ?OVERFLOW ERROR IN line. Arguments less than 
    -89.0296919 evaluate to 0. When the argument doesn't evaluate to a number, the BASIC error ?TYPE MISMATCH ERROR IN line occurs. When the numeric 
    argument is absent, it displays a ?SYNTAX ERROR IN line.
*/
export const exp = async (args) => {
    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    // Check for overflow.
    if (Math.abs(args) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Calculate the exponential.
    if (args < -89.0296919) {
        return 0;
    }

    const result = Math.exp(args);

    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Return the result.
    return result;
};